import React from 'react';
const IconRTD = () => (
  <svg
    width="800px"
    height="800px"
    role="img"
    viewBox="0 0 24 24"
    fill="#ffffff"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 16H6C4.89543 16 4 16.8954 4 18V18C4 19.1046 4.89543 20 6 20H18"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 16V3H7C5.34315 3 4 4.34315 4 6V18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <line
      x1="17"
      y1="16"
      x2="17"
      y2="20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default IconRTD;
